<div class="buttons">
  <cgw-action-button
    mat-button
    [data]="arrowLeftButton">
  </cgw-action-button>

  <cgw-action-button
    class="ml-2"
    mat-button
    [data]="arrowRightButton">
  </cgw-action-button>
</div>
